import {
  SET_FORM_DATA,
  SET_FORM_LOADING,
  SET_MANUFACTURER_ID,
  SET_MRP,
  SET_OFFER_PRICE,
  SET_VARIANT_ID,
  SET_VENDOR_PRICE,
  SET_SUBMIT_LOADING
} from './constants';

export function setFormLoading(loading) {
  return {
    type: SET_FORM_LOADING,
    loading
  };
}

export function setFormDataToStore(formData) {
  return {
    type: SET_FORM_DATA,
    formData
  };
}

export function setMRP(mrp) {
  return {
    type: SET_MRP,
    mrp
  };
}

export function setOfferPrice(offerPrice) {
  return {
    type: SET_OFFER_PRICE,
    offerPrice
  };
}

export function setVendorPrice(vendorPrice) {
  return {
    type: SET_VENDOR_PRICE,
    vendorPrice
  };
}

export function setVariantId(variantId) {
  return {
    type: SET_VARIANT_ID,
    variantId
  };
}

export function setManufacturerId(manufacturerId) {
  return {
    type: SET_MANUFACTURER_ID,
    manufacturerId
  };
}

export function setSubmitLoading(submitLoading) {
  return {
    type: SET_SUBMIT_LOADING,
    submitLoading
  };
}



// WEBPACK FOOTER //
// ./src/Modules/CreateNewManufacturerVariant/actions.js